import { isFilledObject } from '../../AppHelpers'

export default class CurrentPlayingAsset {
  constructor(obj) {
    if (isFilledObject(obj)) {
      this.id = obj.id
      this.type = obj.type
      this.title = obj.title
      this.artist = obj.artist

      this.proxyImage = obj.proxied_artwork
      this.image = obj.artwork
    }
  }
}
